import axios from "axios";
import { getUrl } from "./urls";
import moment from "moment-timezone";

export const FETCH_WORDCLOUD_DATA = "FETCH_WORDCLOUD_DATA";
export const TOGGLE_WORDCLOUDMODAL_SHOW = "TOGGLE_WORDCLOUDMODAL_SHOW";
export const EXCLUDE_WORDCLOUD_WORDS = "EXCLUDE_WORDCLOUD_WORDS";
export const SET_WORDCLOUD_TYPE = "SET_WORDCLOUD_TYPE";

let getReqParams = (data, type) => {
    let params = new URLSearchParams();

    !data.emptyTopics && params.append("topic_data", JSON.stringify(data.topics_data));
    // params.append('topic_data', JSON.stringify(data.topics_data))

    // debugger
    if (["Key Opinion Leaders", "Scanner"].includes(data.name)) params.append("post_type", "0");

    data.languages && params.append("language", data.languages);
    data.countries && params.append("location", data.countries);
    data.platforms && params.append("platform", data.platforms);

    let tz = JSON.parse(localStorage.company).user_timezone_name;
    if (data.duration === "custom") {
        params.append("start_date", moment(data.start_date).tz(tz).format("YYYY-MM-DDTHH:mm:00"));
        params.append("end_date", moment(data.end_date).tz(tz).format("YYYY-MM-DDTHH:mm:00"));
    } else if (data.duration === "24HRS") {
        params.append("end_date", moment(new Date()).tz(tz).format("YYYY-MM-DDTHH:mm:00"));
        params.append("start_date", moment(new Date()).tz(tz).subtract(1, "days").format("YYYY-MM-DDTHH:mm:00"));
    } else {
        params.append("duration", data.duration);
    }

    if (data.duration === "custom" && data.rollingDate) {
        params.delete("end_date");
        params.append("end_date", moment(new Date()).tz(tz).format("YYYY-MM-DDTHH:mm:00"));
    }

    if (data.entityType !== "all" && data.entityType !== "") {
        formatEntityType(params, data.entityType, data.entitySubType);
    }

    if (data.publications) {
        if (data.publications === "all_tagged_pubs") params.append("fields_exist", "publications");
        else if (data.publications === "all_untagged_pubs") params.append("fields_not_exist", "publications");
        else if (data.publications === "not_listed_pubs") {
            let configured_publications = JSON.parse(localStorage.getItem("filterOptions")).publications.map((elem) => elem.name);
            params.append("publications_not_in", configured_publications.toString());
        } else params.append("publication", data.publications);
    }

    if (data.custom_query && data.custom_query !== "") params.append("custom_query", data.custom_query);

    params.append("aggs", type === "frequency" ? "frequency-wordcloud" : "impact-wordcloud");
    params.append("size", 100);

    data.drilldownwords && params.append("wordcloud_drilldown_query", data.drilldownwords);

    return params;
};

export function fetchWordCloudData(filter, type) {
    let data = getReqParams(filter, type);
    let req = axios({
        url: getUrl("raw_data"),
        method: "post",
        data,
    })
        .then((res) => res.data)
        .then((dt) => {
            return dt;
        });

    return {
        type: FETCH_WORDCLOUD_DATA,
        payload: req,
    };
}

export function setWordCloudModalShow(show) {
    return {
        type: TOGGLE_WORDCLOUDMODAL_SHOW,
        payload: show,
    };
}

export function excludeWords(words) {
    let data = new URLSearchParams();
    data.append("words", words);
    data.append("company", JSON.parse(localStorage.getItem("company")).company_identifier);
    let req = axios({
        method: "post",
        url: getUrl("wordcloud_exclude"),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data,
    }).then((res) => res.data);

    return {
        type: EXCLUDE_WORDCLOUD_WORDS,
        payload: req,
    };
}

export const setWordCloudType = (type) => {
    return {
        type: SET_WORDCLOUD_TYPE,
        payload: type,
    };
};

const formatEntityType = (params, et, est) => {
    let paramest = [];
    let entityType = et.split(",");
    let entitySubType = est.split(",");

    let boolStrings = [];

    if (entityType.includes("person")) {
        let personBoolean = "post.entity_type:person ";
        let subParams = [];
        if (entitySubType.includes("male")) subParams.push("male");
        if (entitySubType.includes("female")) subParams.push("female");
        if (entitySubType.includes("unknown")) subParams.push("unknown");
        if (subParams.length) {
            subParams = subParams.map((sp) => "post.entity_sub_type:" + sp).join(" OR ");
            personBoolean += `AND (${subParams})`;
        }
        boolStrings.push(`(${personBoolean})`);
    }

    if (entityType.includes("non-person")) {
        let nonPerBoolean = "post.entity_type:non-person ";
        let subParams = [];
        if (entitySubType.includes("brand")) subParams.push("brand");
        if (entitySubType.includes("news")) subParams.push("news");
        if (subParams.length) {
            subParams = subParams.map((sp) => "post.entity_sub_type:" + sp).join(" OR ");
            nonPerBoolean += `AND (${subParams})`;
        }
        boolStrings.push(`(${nonPerBoolean})`);
    }

    if (entityType.includes("unknown")) {
        boolStrings.push(`(post.entity_type:unknown)`);
    }

    params.append("entity_boolean", boolStrings.join(" OR "));
};
